import { simactivationApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const triggerESIMActivationEmail = (payload) => {
  const url = simactivationApi.TRIGGER_ESIM_ACTIVATION_EMAIL;
  return axios.post(url, payload);
};


export const triggerESIMActivationMultiRecp = (payload) => {
  const url = simactivationApi.UPLOAD_RETRIGGER_ESIM_ACTIVATION;
  return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const triggerSimActivationStatus = (payload) => {
  const url = simactivationApi.SIM_ACTIVATION_STATUS_REQUEST;
  return axios.post(url, payload);
}

export const triggerSimActivationSubmit = (payload) => {
  const url = simactivationApi.SIM_ACTIVATION_SUBMIT_REQUEST;
  return axios.post(url, payload);
}